import { render, staticRenderFns } from "./JobTemplate.vue?vue&type=template&id=4d787f88&scoped=true&lang=pug"
import script from "./JobTemplate.vue?vue&type=script&lang=ts"
export * from "./JobTemplate.vue?vue&type=script&lang=ts"
import style0 from "./JobTemplate.vue?vue&type=style&index=0&id=4d787f88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d787f88",
  null
  
)

/* custom blocks */
import block0 from "./JobTemplate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FJobTemplate%2FJobTemplate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports